module.exports = __webpack_public_path__ + "static/media/afterparty_logo.ef8d221b.png";